import React, { useEffect, useState } from "react";
import axios from "axios";
import Card from "react-bootstrap/Card";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import 'bootstrap/dist/css/bootstrap.min.css';
import Api_key from "./apiconfiguration";

const CastList = ({ id }) => {
  const [cast, setCast] = useState([]);
  const [visibleCount, setVisibleCount] = useState(4);
  const apiKey = Api_key;

  useEffect(() => {
    const fetchCastDetails = async () => {
      try {
        const castEndpoint = `https://api.themoviedb.org/3/tv/${id}/credits?api_key=${apiKey}`;
        const response = await axios.get(castEndpoint);
        setCast(response.data.cast);
      } catch (error) {
        console.error(error);
      }
    };

    fetchCastDetails();
  }, [id]);

  const handleShowMore = () => {
    setVisibleCount((prevCount) => prevCount + 4);
  };

  return (
    <Container className="cast-shell">
      <div className="section-heading"><div><span>THE PEOPLE</span><h2>Cast & characters</h2></div><small>{cast.length} credits</small></div>
      <Row className="cast-grid">
        {cast.slice(0, visibleCount).map((member) => (
          <Col key={member.id} xs={6} md={3} className="mb-4">
            <Card className="cast-card">
              <Card.Img
                variant="top"
                src={
                  member.profile_path
                    ? `https://image.tmdb.org/t/p/w500${member.profile_path}`
                    : "https://via.placeholder.com/500x750?text=No+Image"
                }
                alt={member.name}
                loading="lazy"
              />
              <Card.Body>
                <Card.Title>{member.name}</Card.Title>
                <Card.Text>{member.character || 'Cast member'}</Card.Text>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
      {visibleCount < cast.length && (
        <div className="text-center mt-3">
          <Button variant="primary"  style={{
              borderRadius: "25px",
              padding: "10px 25px",
              fontSize: "16px",
              backgroundColor: "#1e90ff",
              border: "none",
              color: "#fff",
              boxShadow: "0 4px 10px rgba(30, 144, 255, 0.3)",
            }} onClick={handleShowMore}>Show More</Button>
        </div>
      )}
    </Container>
  );
};

export default CastList;
